/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import _ from "lodash";
import OtherAsset from "./OtherAsset/OtherAsset";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import { Box, SelectChangeEvent } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const OtherAssets = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const empty = {
    name: "",
    ownership: "",
    value: "",
  };

  const initialValues = {
    hasOtherAssets: pcs.hasOtherAssets,
    otherAssets: !_.isEmpty(pcs.otherAssets) ? pcs.otherAssets : [empty],
  };

  const { values, handleChange, handleSubmit, errors, touchedValues, handleBlur } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  const add = () => {
    const otherAssets = values.otherAssets || [];
    if (otherAssets.length >= 3) {
      return;
    }

    otherAssets.push(empty);

    handleChange({
      target: {
        type: "other",
        name: "otherAssets",
        value: otherAssets,
      },
    });
  };

  const handleMore = ({ target }: SelectChangeEvent) => {
    const { name, value } = target;
    if (value === "yes") {
      add();
    }
    if (value === "no") {
      const splitName = _.split(name, "-");
      const lastPart = splitName[splitName.length - 1];
      const key = parseInt(lastPart);
      handleChange({
        target: {
          type: "other",
          name: "otherAssets",
          value: _.slice(values.otherAssets, 0, key + 1),
        },
      });
    }
  };

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Vermögenswerte</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Haben Sie weitere Vermögenswerte?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Weitere Vermögenswerte"}
              name={"hasOtherAssets"}
              value={formValue(values, "hasOtherAssets")}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          {values.hasOtherAssets === "yes" && (
            <>
              {_.map(values.otherAssets, (otherAsset, key) => (
                <React.Fragment key={key}>
                  <OtherAsset path={`otherAssets[${key}]`} otherAsset={otherAsset} handleChange={handleChange} />
                  {parseInt(key) < 2 && (
                    <>
                      <Grid sx={processCostSupportStyle.question} size={12}>
                        Haben Sie einen weiteren Vermögenswert?
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 6,
                          lg: 4
                        }}>
                        <ValidatorSelect
                          label={"Weiterer Vermögenswert"}
                          name={`hasMore-${key}`}
                          value={formValue(values, "otherAssets").length - 1 > parseInt(key) ? "yes" : "no"}
                          onChange={handleMore}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={"no"}>Nein</MenuItem>
                          <MenuItem value={"yes"}>Ja</MenuItem>
                        </ValidatorSelect>
                      </Grid>
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default OtherAssets;
